import { render } from "./OrçamentoPorProjeto.vue?vue&type=template&id=4800b3ab"
import script from "./OrçamentoPorProjeto.vue?vue&type=script&lang=js"
export * from "./OrçamentoPorProjeto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__